import {RouterOutlet} from '@angular/router';
import {SidenavComponent} from "./core/layout/pages/sidenav/sidenav.component";
import {NavbarComponent} from "./core/layout/pages/navbar/navbar.component";
import {ConfirmationService} from 'primeng/api';
import {ToastModule} from "primeng/toast";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ModalContainerComponent} from "./core/components/modal-container/modal-container.component";
import {DisableGlobalRightClickDirective} from "./core/directives/disable-global-right-click.directive";
import {Component, inject} from "@angular/core";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ToastModule, ConfirmDialogModule, ModalContainerComponent],
    templateUrl: './app.component.html',
    providers: [ConfirmationService]
})
export class AppComponent {
    title = 'manage';
}

